var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9904,
    cy: 13,
    rx: 12.9909,
    ry: 13,
    fill: "#006B00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53951 13.5C6.53951 12.124 6.80351 11.04 7.33151 10.248C7.86751 9.456 8.72751 9.06 9.91151 9.06C11.0955 9.06 11.9515 9.456 12.4795 10.248C13.0155 11.04 13.2835 12.124 13.2835 13.5C13.2835 14.892 13.0155 15.984 12.4795 16.776C11.9515 17.568 11.0955 17.964 9.91151 17.964C8.72751 17.964 7.86751 17.568 7.33151 16.776C6.80351 15.984 6.53951 14.892 6.53951 13.5ZM11.2675 13.5C11.2675 12.692 11.1795 12.072 11.0035 11.64C10.8275 11.2 10.4635 10.98 9.91151 10.98C9.35951 10.98 8.99551 11.2 8.81951 11.64C8.64351 12.072 8.55551 12.692 8.55551 13.5C8.55551 14.044 8.58751 14.496 8.65151 14.856C8.71551 15.208 8.84351 15.496 9.03551 15.72C9.23551 15.936 9.52751 16.044 9.91151 16.044C10.2955 16.044 10.5835 15.936 10.7755 15.72C10.9755 15.496 11.1075 15.208 11.1715 14.856C11.2355 14.496 11.2675 14.044 11.2675 13.5ZM14.2956 16.356C14.5676 16.14 14.6916 16.04 14.6676 16.056C15.4516 15.408 16.0676 14.876 16.5156 14.46C16.9716 14.044 17.3556 13.608 17.6676 13.152C17.9796 12.696 18.1356 12.252 18.1356 11.82C18.1356 11.492 18.0596 11.236 17.9076 11.052C17.7556 10.868 17.5276 10.776 17.2236 10.776C16.9196 10.776 16.6796 10.892 16.5036 11.124C16.3356 11.348 16.2516 11.668 16.2516 12.084H14.2716C14.2876 11.404 14.4316 10.836 14.7036 10.38C14.9836 9.924 15.3476 9.588 15.7956 9.372C16.2516 9.156 16.7556 9.048 17.3076 9.048C18.2596 9.048 18.9756 9.292 19.4556 9.78C19.9436 10.268 20.1876 10.904 20.1876 11.688C20.1876 12.544 19.8956 13.34 19.3116 14.076C18.7276 14.804 17.9836 15.516 17.0796 16.212H20.3196V17.88H14.2956V16.356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.3f16bef773bfa5b5b5dedc5927991d8c.svg";
export { ForwardRef as ReactComponent };